import moment from "moment";

export const filterRecords = (type, value) => {
  if (type === "upcoming") {
    if (removeOnUpcomingStatus.includes(value)) {
      return false;
    }
    return true;
  }
  if (type === "past") {
    if (removeOnPastStatus.includes(value)) {
      return false;
    }
    return true;
  }
};

export const removeOnUpcomingStatus = [
  "completed",
  "cancel_self",
  "cancel_staff",
  "cancel_patient",
  "no_show",
];

export const removeOnPastStatus = [
  "upcoming",
  "reschedule_self",
  "reschedule_staff",
  "reschedule_patient",
];
export const filters = {
  sideMenu: [
    {
      name: "Date",
      value: "date",
    },
    {
      name: "Doctor Name",
      value: "doctorName",
    },
    {
      name: "Prescription",
      value: "prescriptionStatus",
    },
    {
      name: "Consultation",
      value: "status",
    },
    {
      name: "Appointment Status",
      value: "appointmentStatus",
    },
  ],
  date: [
    {
      name: "Today",
      value: "Today",
    },
    {
      name: "Last 7 Days",
      value: "Last 7 Days",
    },
    {
      name: "Last 30 Days",
      value: "Last 30 Days",
    },
    {
      name: "Date Range",
      value: "Date Range",
    },
  ],
  appointmentStatus: [
    {
      name: "All",
      value: "all",
    },
    {
      name: "Upcoming",
      value: "upcoming",
    },
    {
      name: "In Progress",
      value: "in_progress",
    },
    {
      name: "Completed",
      value: "completed",
    },
    {
      name: "Rescheduled By Me",
      value: "reschedule_self",
    },
    {
      name: "Rescheduled By Staff",
      value: "reschedule_staff",
    },
    {
      name: "Patient Rescheduled",
      value: "reschedule_patient",
    },
    {
      name: "Cancelled By Me",
      value: "cancel_self",
    },
    {
      name: "Cancelled By Staff",
      value: "cancel_staff",
    },
    {
      name: "Patient Cancelled",
      value: "cancel_patient",
    },
    {
      name: "No Show",
      value: "no_show",
    },
  ],
  status: [
    {
      name: "All",
      value: "all",
      type: "consultation",
    },
    {
      name: "Tele-Consult Regular",
      value: "online-regular",
      type: "consultation",
    },
    {
      name: "Tele-Consult Follow-Up",
      value: "online-followup",
      type: "consultation",
    },
    {
      name: "In-Clinic Regular",
      value: "inclinic-regular",
      type: "consultation",
    },
    {
      name: "In-Clinic Follow-Up",
      value: "inclinic-followup",
      type: "consultation",
    },
    {
      name: "Instant",
      value: "instant",
      type: "consultation",
    },
  ],
  prescriptionStatus: [
    {
      name: "All",
      value: "all",
    },
    {
      name: "Prescription Shared",
      value: "shared",
    },
    {
      name: "Prescription Not Shared",
      value: "not_shared",
    },
  ],
  doctorName: [],
  allDoctorsRelatedData: localStorage.getItem("allDoctorsRelatedData"),
};

export const tableHeader = [
  {
    name: "DATE & TIME",
    value: "created_at",
    method: "date",
    method2: "time",
  },
  {
    name: "PATIENT NAME",
    value: "patient_name",
  },
  {
    name: "MOBILE NUMBER",
    value: "patient_phone_no",
  },
  {
    name: "Consultation",
    value: "payment_method",
  },
  {
    name: "STATUS",
    value: "status",
    method: "status",
  },
  {
    name: "Action",
  },
];

export function status(value) {
  return value == "2"
    ? "Cancelled"
    : value == "1"
    ? "Completed"
    : value == "3"
    ? "Patient Rescheduled"
    : "Rescheduled (By me)";
}

export function date(value) {
  return moment(value).format("DD MMM YYYY");
}

export function time(value) {
  return moment(value).format("hh:mm A");
}

export function dateRange(start, end) {
  let dateStatus = "Date Range";
  const Today = new Date();
  const today = moment(new Date()).format("YYYY-MM-DD");

  const lastWeekMonth = moment(
    new Date(Today.getFullYear(), Today.getMonth() - 1, Today.getDate())
  ).format("YYYY-MM-DD");

  const lastWeek = moment(
    new Date(Today.getFullYear(), Today.getMonth(), Today.getDate() - 7)
  ).format("YYYY-MM-DD");
  if ((start === "" && end === "") || (start == end && start == today)) {
    dateStatus = "Today";
  } else if (
    (start == today || end == today) &&
    (start == lastWeek || end == lastWeek)
  ) {
    dateStatus = "Last 7 Days";
  } else if (
    (start == today || end == today) &&
    (start == lastWeekMonth || end == lastWeekMonth)
  ) {
    dateStatus = "Last 30 Days";
  } else {
    dateStatus = "Date Range";
  }
  return dateStatus;
}

export function getDateByRanges(value) {
  let dateRange = {
    startDate: new Date(),
    endDate: new Date(),
  };
  const Today = new Date();
  const today = moment(new Date()).format("YYYY-MM-DD");

  const lastWeekMonth = moment(
    new Date(Today.getFullYear(), Today.getMonth() - 1, Today.getDate())
  ).format("YYYY-MM-DD");

  const lastWeek = moment(
    new Date(Today.getFullYear(), Today.getMonth(), Today.getDate() - 7)
  ).format("YYYY-MM-DD");

  if (value == "Today") {
    dateRange = {
      startDate: today,
      endDate: today,
    };
  } else if (value == "Last 7 Days") {
    dateRange = {
      startDate: lastWeek,
      endDate: today,
    };
  } else if (value == "Last 30 Days") {
    dateRange = {
      startDate: lastWeekMonth,
      endDate: today,
    };
  }
  return dateRange;
}
